import React from "react";
import { Margin } from "~/components/elements";

import * as S from "./styles";

import Exit from "~/assets/img/icon/modal-close.svg";
import ReactSVG from "react-svg";
import isMobile from "~/hooks/isMobile";
import celebration from "~/assets/img/icon/celebration.svg";

export default function WinnerModal({ openModal, handleModalWinner }) {
  const mobile = isMobile();
  return (
    <S.Shade
      open={!!openModal}
      onClick={() => {
        handleModalWinner(false);
      }}
    >
      <S.ModalBox
        open={!!openModal}
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        {!mobile && (
          <S.Exit onClick={() => handleModalWinner(false)}>
            <ReactSVG wrapper="div" src={Exit} />
          </S.Exit>
        )}
        <S.TitleHolder>
          <Margin mb={2}>
            <ReactSVG src={celebration} />
          </Margin>
          VALE PRÊMIO INSTANTÂNEO
        </S.TitleHolder>

        <S.Text>
        Parabéns, você é um possível ganhador do prêmio instantâneo.
        <br></br>
          Entraremos em contato para validar o seu prêmio.
        </S.Text>

        <S.Button onClick={() => handleModalWinner(false)}>
          OK
        </S.Button>

      </S.ModalBox>
    </S.Shade>
  );
}
